<!--suppress ALL -->
<script lang="ts">
import {asramas} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class AsramaSantriSelect extends Vue {

    @Prop({default: asramas[0].value, type: String})
    public asrama: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectAsrama(param: any) {
      this.$emit('update:asrama', param || asramas[0].value);
      this.$emit('asrama-selected', param);
    }

    public render(createElement: Function) {
      const {$t, asrama, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: asrama,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.asrama')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectAsrama}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(asramas).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.asrama'), message, type}}, [main]);
    }
  }
</script>
